import './product-features.scss';
import { initSelectors } from '../../../assets/src/ts/utils/selector';

initSelectors();
